import { MapPin } from 'phosphor-react'
import React, { useState, useEffect, useMemo, useRef, Suspense } from 'react'

import ButtonFriendPlus from './components/ButtonFriendPlus'
import { DeliveryInfosText } from './components/DeliveryInfosText'
import { ProfileDropdown } from './components/ProfileDropdown'
import { CartHeaderIconV2 } from '../../../assets/CartHeaderIconV2'
import { UserHeaderIcon } from '../../../assets/UserHeaderIcon'
import { useClubContext } from '../../../contexts/ClubContext'
import { useRegionalizationContext } from '../../../contexts/RegionalizationContext'
import { useSearchOverlayContext } from '../../../contexts/SearchOverlayContext'
import { useStoreContext } from '../../../contexts/StoreContext'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { useCart } from '../../../sdk/cart'
import { useCartToggleButton } from '../../../sdk/cart/useCartToggleButton'
import { useSession } from '../../../sdk/session'
import useOnClickOutside from '../../../sdk/ui/useOnClickOutside'
import Button from '../../ui/Button'

import './navbar.scss'

const SecondColumnHeader = () => {
  const {
    city,
    uf,
    setOpenRegionModal,
    regionalized,
    pickupName,
    pickupTimes,
  } = useRegionalizationContext()

  const { onClick } = useCartToggleButton()
  const { totalItems } = useCart()
  const { person } = useSession()
  const { isClubClient, userInfos: clubUserInfos } = useClubContext()
  const { secureSubdomain, loginUrl } = useStoreContext()
  const dropdownContainerRef = useRef<HTMLLabelElement>(null)
  const { isMobile: isMobileHook } = useWindowDimensions()
  const { setVisibleSearchOverlay } = useSearchOverlayContext()
  const userInfos = useMemo(() => {
    if (person) {
      return person
    }

    if (isClubClient) {
      return clubUserInfos
    }

    return undefined
  }, [clubUserInfos, person, isClubClient])

  const [isMobile, setIsMobile] = useState<boolean | null>(null)
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false)

  useOnClickOutside(dropdownContainerRef, () => {
    profileDropdownOpen && handleOpenProfileDropdown(false)
  })

  const handleOpenProfileDropdown = (open: boolean) => {
    setVisibleSearchOverlay?.(open)
    setProfileDropdownOpen(open)
  }

  useEffect(() => {
    setIsMobile(isMobileHook)
  }, [isMobileHook])

  const isDelivery = regionalized === 'delivery'

  return (
    <div className="navbar__buttons justify-content-center">
      <div className="mobile-cart-use">
        <ButtonFriendPlus />
        <a
          aria-label="Login or Account"
          data-button-signin-link
          href={userInfos ? `${secureSubdomain}/api/io/account#/` : loginUrl}
          className="title-sub-subsection signin-link"
        >
          <UserHeaderIcon />
        </a>
        <button
          aria-label="Cart button"
          className="button-modal-open-cart cart-toggle"
          onClick={onClick}
        >
          <span className="alignment">
            <CartHeaderIconV2 className="cart-toggle" />
            {totalItems > 0 && <div className="totalCart">{totalItems}</div>}
          </span>
        </button>
      </div>
      <div className="desk-cart-user">
        <div className="d-flex justify-content-around items-center ">
          <Button
            className="geolocation-desktop d-flex justify-contente-around items-center pointer"
            onClick={() => setOpenRegionModal?.(true)}
          >
            <div className="containerIco map-pin-icon">
              <MapPin size={34} />
            </div>
            <div className="region">
              {regionalized ? (
                <DeliveryInfosText
                  pickupPointTime={pickupTimes}
                  storeName={pickupName}
                  city={city}
                  isDelivery={isDelivery}
                  uf={uf}
                />
              ) : (
                <span>
                  Escolha o local de <br /> entrega ou retirada
                </span>
              )}
            </div>
          </Button>
          <ButtonFriendPlus />
          {isMobile || (!isMobile && !userInfos) ? (
            <a
              aria-label="Login or Account"
              data-button-signin-link
              href={
                userInfos ? `${secureSubdomain}/api/io/account#/` : loginUrl
              }
              className="title-sub-subsection signin-link login-desktop d-flex justify-content-around items-center"
            >
              <div className="containerIco header-icon">
                <UserHeaderIcon />
              </div>
              <div>
                <span>Entrar</span>
              </div>
            </a>
          ) : (
            <>
              <Button
                aria-label="Login or Account"
                data-button-signin-link
                className="title-sub-subsection signin-link login-desktop d-flex justify-content-around items-center"
                onClick={() => handleOpenProfileDropdown(!profileDropdownOpen)}
              >
                <div className="containerIco header-icon">
                  <UserHeaderIcon />
                </div>

                <label
                  className="desk-cart-user-info-container"
                  ref={dropdownContainerRef}
                >
                  <span>Bem-Vindo</span>
                  <p className="login">
                    {userInfos?.givenName && userInfos?.familyName
                      ? `${userInfos?.givenName} ${userInfos?.familyName}`
                      : userInfos?.email}
                  </p>

                  {profileDropdownOpen && (
                    <Suspense fallback={null}>
                      <ProfileDropdown />
                    </Suspense>
                  )}
                </label>
              </Button>
            </>
          )}

          <Button
            aria-label="Cart button"
            onClick={onClick}
            className="d-flex justify-content-around items-center my-cart"
          >
            <div className="containerIco cartIcon">
              <CartHeaderIconV2 className="cart-toggle" />
              {totalItems > 0 && <div className="totalCart">{totalItems}</div>}
            </div>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SecondColumnHeader
